<template>
  <v-container class="pa-6">
    <div style="margin-bottom: 24px;">
      <div class="component-title">{{ profile.name }}</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="breadcrumbItems">
        <template v-slot:divider class="pa-0">
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>
    <ProductInfo :profile="profile" :types="types" @refresh="refresh" />
    <v-card style="margin-bottom: 24px;" outlined>
      <div class="d-flex justify-space-between align-items-center px-6 py-6 ">
        <h5 class=" text-uppercase align-self-center grey--text">Lịch sử thao tác</h5>
      </div>
      <ProductLog :items="logs" />
    </v-card>
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
import ProductInfo from './ProductInfo.vue'
import ProductLog from './ProductLog.vue'

export default {
  data() {
    return {
      profile: {},
      logs: [],
      types: []
    }
  },
  computed: {
    breadcrumbItems() {
      return [
        {
          text: 'Danh sách hệ đào tạo',
          disabled: false,
          href: `/admin/product/`
        },
        {
          text: 'Thông tin hệ đào tạo',
          disabled: false
        }
      ]
    }
  },
  components: {
    ProductInfo,
    ProductLog
  },
  mounted() {
    this.getProfileData()
    this.getLogs()
    this.getTypes()
  },
  methods: {
    ...mapActions('product', ['fetchProduct', 'fetchProductTypes']),
    ...mapActions('leadLog', ['fetchLogs']),
    async getProfileData() {
      this.$loading.active = true
      const id = this.$route.params.id
      const response = await this.fetchProduct(id)
      this.profile = response
      this.$loading.active = false
    },

    refresh() {
      this.getProfileData()
      this.getLogs()
    },
    async getLogs() {
      const id = this.$route.params.id

      const logs = await this.fetchLogs({product: id})
      if (logs) {
        this.logs = logs.sort((a, b) => new Date(a.time) - new Date(b.time))
      }
    },
    async getTypes() {
      this.types = await this.fetchProductTypes({})
    }
  }
}
</script>

<style>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
</style>
